module.exports = __webpack_public_path__ + "img/5.99c581d4.jpg";